<template>
  <div class="user-banner">
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item name="1">
        <template v-if="!active" slot="title">
          <Icon class="mr-5" :type="'user'" />
          {{ user.fullName }}
        </template>
        <div
          class="flex justify-between p-8 lg:flex-row flex-col justify-items-stretch"
        >
          <div class="col-xs-6">
            <b>Name:</b>
            <ul class="list-unstyled mt-xxxs">
              <li>
                {{ user.fullName }}
              </li>
            </ul>
          </div>

          <template v-if="isTrainee">
            <div v-if="isActive" class="col-xs-6">
              <b>Group</b>
              <ul class="list-unstyled mt-xxxs">
                <li v-for="group in user.groups" :key="group.id">
                  <router-link
                    :to="{
                      name: 'companies_groups@show',
                      params: { id: group.id },
                    }"
                    class="link"
                  >
                    {{ group.name }}
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- <div
              v-if="user.company.rpe.length"
              class="lg:px-6"
            >
              <b> Registry, Purpose, Equipment </b>
              <ul class="list-unstyled mt-xxxs">
                <li
                  v-for="rpe in user.company.rpe"
                  :key="rpe.id"
                >
                  {{ rpe.name }}
                </li>
              </ul>
            </div> -->

            <div v-if="userRoleList.length" class="col-xs-6">
              <!-- <b>Roles</b> -->
              <ul class="list-unstyled mt-xxxs">
                <li v-for="role in userRoleList" :key="role.id">
                  <b> {{ role.name }} Licence: </b>
                  <p class="ml-xs text-xl">
                    {{ role.licence }}
                  </p>
                </li>
              </ul>
            </div>

            <!-- <div class="lg:px-6">
              <b>Hemisphere</b>
              <ul class="list-unstyled mt-xxxs">
                <li>
                  {{ user.hemisphereName }}
                </li>
              </ul>
            </div> -->
            <div v-if="isActive" class="col-xs-6">
              <b>Subscription</b>
              <ul class="list-unstyled mt-xxxs">
                <li>
                  {{ subscriptionEnd }}
                </li>
              </ul>
            </div>

            <div v-if="!isActive" class="col-xs-6">
              <b>Start</b>
              <ul class="list-unstyled mt-xxxs">
                <li>
                  {{ createdAt }}
                </li>
              </ul>
            </div>

            <div v-if="!isActive" class="col-xs-6">
              <b>End</b>
              <ul class="list-unstyled mt-xxxs">
                <li>
                  {{ deletedAt }}
                </li>
              </ul>
            </div>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Vue from "vue";
import { Collapse, CollapseItem, Loading } from "element-ui";
import HelperDate from "@helpers/dates";
import { mapGetters } from "vuex";
import rolesConstants from "@/components/acl/roles";
import Icon from "@components/UIComponents/TopicIcon/Icon";

Vue.use(Loading.directive);
Vue.use(Collapse);
Vue.use(CollapseItem);

export default {
  components: {
    Icon,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeNames: [],
      title: "",
      active: false,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    subscriptionEnd() {
      return HelperDate.formatDate(this.user.subscription.end);
    },
    createdAt() {
      return HelperDate.formatDate(this.user.created_at);
    },
    deletedAt() {
      return HelperDate.formatDate(this.user.deleted_at);
    },
    isTrainee() {
      const userAcl = this.user.acl.roles;
      return userAcl.some((acl) => acl.name === rolesConstants.ROLE_TRAINEE);
    },
    userRoleList() {
      const list = [];
      for (const role of this.user.company.roles) {
        if (!role.licence) {
          continue;
        }
        list.push(role);
      }
      return list;
    },
    isActive() {
      return this.user.isActive;
    },
  },
  methods: {
    handleChange() {
      return (this.active = !this.active);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/paper/variables";
.user-banner {
  margin-bottom: 30px;
  .el-collapse-item {
    box-shadow: 0 6px 10px -4px #00000026;
  }
  .el-collapse-item * {
    color: $font-color;
  }

  .link {
    color: $info-color;
  }

  .el-collapse-item .el-collapse-item__header:hover,
  .el-collapse-item .el-collapse-item__header:active,
  .el-collapse-item .el-collapse-item__header:focus {
    color: $font-color;
  }
}
</style>
